<template>
  <div id="app" class="app">
    <router-view />
    <div class="fixed-wrap" v-if="name!=='GuidePage'&&name!=='CheckExamAnswer'&&name!=='StartExam'">
      <span class="item" style="border-bottom: 1px dashed #d0d0d0;"><i class="iconfont icon-weixin"></i>客服
        <div class="box-wrapper h">
          <div class="box">
            <img src="./assets/img/chat.png" style="width:118px;">
            <div><i class="iconfont icon-weixin"></i>华警招警</div>
            <div style="margin-top: 10px;">工作时间 9:00-17:00</div>
          </div>
        </div>
      </span>
      <span @click="pathTo" class="item" style="border-bottom: 1px dashed #d0d0d0;"><i class="iconfont icon-monijikao"></i>机考</span>
      <span @click="$router.push({path:'/'})" class="item"><i class="iconfont icon-zhuye"></i>返回主页</span>
    </div>
    <div v-if="name == 'Index' || name == 'ExamOutline' || name == 'Brand' || name == 'UploadFile' || name == 'UploadFileDetail'|| name == 'ComputerPage'" style="display: flex;justify-content: center;padding: 10px;"><a style="color: #222;" href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2023019828号</a></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      permission: false,
      name: ''
    }
  },
  updated() {
    this.permission = sessionStorage.getItem('token')
    this.name = this.$route.name
  },
  methods: {
    pathTo() {
      this.$router.push({
        path: '/examList'
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.app {
  height: 100%;
  overflow: auto;

  >div {
    background-color: #f8f8f8;
  }

  .fixed-wrap {
    z-index: 999;
    position: fixed;
    right: 60px;
    top: 40%;
    width: 70px;
    background: #f2f2f2;
    border-radius: 8px;

    .item {
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      span {
        font-size: 14px;
      }

      i {
        font-size: 30px;
        color: red;
      }

      .box-wrapper {
        position: absolute;
        top: -10px;
        right: 70px;
        z-index: 1;
        padding-right: 12px;
      }

      .h {
        visibility: hidden;
      }

      .box-wrapper.h {
        opacity: 0;
        transition: all .3s ease;
      }

    }

    .item:hover .h {
      visibility: visible;
      top: 0;
      opacity: 1;
    }

    .box {
      text-align: center;
      padding: 21px 0;
      position: relative;
      width: 200px;
      border: 1px solid #d5dfe4;
      background: #fff;
      border-radius: 4px;
      box-sizing: border-box;

      div {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        line-height: 1;
        height: 16px;
        padding-top: 10px;
        font-size: 16px;
        color: #333;

        .icon-weixin {
          color: #7ed200;
        }
      }
    }

    .box:before {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      transform: rotate(45deg);
      top: 11px;
      right: -6px;
      z-index: 2;
      border-width: 6px;
      border-color: transparent #fff transparent transparent;
    }
    .box:after {
      top: 8px;
      right: -8px;
      z-index: 1;
      border-width: 8px;
      border-color: transparent #d5dfe4 transparent transparent;
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      transform: rotate( 45deg );
    }
  }
}</style>
